import React, { useState } from "react";
import { Box, List, ListItem, Button } from "@mui/material";

export default function Highlights({ highlightsData }) {
  const [showAll, setShowAll] = useState(false);

  const BulletItem = ({ children }) => (
    <ListItem
      sx={{
        display: "list-item",
        pl: 0,
        fontSize: 15,
        color: "#374151",
        lineHeight: 1.6,
        "&::marker": { color: "#1e3a8a" },
      }}
    >
      {children}
    </ListItem>
  );

  const visibleItems = showAll ? highlightsData : highlightsData.slice(0, 3);

  return (
    <Box>
      <List sx={{ pl: 2, mt: 1 }}>
        {visibleItems?.map((item, index) => (
          <BulletItem key={index}>{item.content}</BulletItem>
        ))}
      </List>
      {highlightsData.length > 3 && (
        <span
          size="small"
          onClick={() => setShowAll((prev) => !prev)}
          style={{
            fontSize: "13px",
            color: "#007bff",
            cursor: "pointer",
            display: "inline-block",
            marginLeft: "16px",
          }}
          // sx={{ mt: 1, ml: 2, textTransform: "none" }}
        >
          {showAll ? "Read Less" : "Read More"}
        </span>
      )}
    </Box>
  );
}
